const SIZES = {
  sm: "w-8 h-8 text-sm",
  md: "w-12 h-12 text-lg",
  lg: "w-24 h-24 text-4xl",
};

export function Avatar({ name, size = "md", accent = false, className = "", testid }) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  const initials = !parts.length
    ? "?"
    : parts.length === 1
      ? parts[0].slice(0, 2).toUpperCase()
      : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  const tone = accent
    ? "bg-blue-50 border-blue-100 text-blue-700"
    : "bg-slate-100 border-slate-200 text-slate-700";
  return (
    <span data-testid={testid} className={`shrink-0 rounded-full border font-heading font-bold flex items-center justify-center ${SIZES[size]} ${tone} ${className}`}>
      {initials}
    </span>
  );
}
